import { render, staticRenderFns } from "./RoundBody.vue?vue&type=template&id=9c8aaa5e&scoped=true&"
import script from "./RoundBody.vue?vue&type=script&lang=ts&"
export * from "./RoundBody.vue?vue&type=script&lang=ts&"
import style0 from "./RoundBody.vue?vue&type=style&index=0&id=9c8aaa5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8aaa5e",
  null
  
)

export default component.exports